import { render } from "./WidgetPropsCmp.vue?vue&type=template&id=a21ead98"
import script from "./WidgetPropsCmp.vue?vue&type=script&lang=js"
export * from "./WidgetPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__